import { PolicyPaylodData, formatCommonDateStr } from '@jove-frontend/uikit';
import BaseModel from '../BaseModel';

class PolicyDetailInfoModel extends BaseModel implements PolicyPaylodData {
  firstName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
  country?: string;
  businessBuildingName?: null;
  businessBuildingNumber?: null;
  businessFlatNumber?: null;
  businessAddress?: string;
  businessPostcode?: string;
  businessCity?: string;
  businessCountry?: string;
  policyType?: null;
  businessType?: string;
  businessActivity?: string;
  involvedActivities?: null;
  technologyIndustry?: boolean;
  undertakenWork?: boolean;
  workingCompany?: string;
  multipleClients?: null;
  contract1M?: boolean;
  projectPeriodStart?: string;
  projectPeriodEnd?: string;
  policyPeriod?: null;
  income?: number | string;
  turnover?: string | null;
  incomeOrigin?: any;
  covers?: any;
  elSize?: any;
  companyName?: string;
  companyIncorporationDate?: null;
  vehicleRegistrationNumber?: null;
  ern?: string;
  brokerDesk?: null;
  brokerDeskInfo?: any; // todo
  meta?: null;
  switch?: null;
  providerCode?: null;
  providerRefID?: null;
  price?: any;
  switchPrice?: null;
  prices?: any; // todo
  fees?: string;
  labels?: object;
  companyNumber?: string;
  pricesListMap?: object;

  detailedAddress?: string;
  turnoverRaw?: string;
  projectPeriodTimeText?: string;
  quoteId?: string;

  transformServeDataToInstance(data: any) {
    super.transformServeDataToInstance(data);
    if (this.projectPeriodStart && this.projectPeriodEnd) [(this.projectPeriodTimeText = `${formatCommonDateStr(this.projectPeriodStart)} - ${formatCommonDateStr(this.projectPeriodEnd)}`)];
  }

  // conver request data
  covertToServerRequestData() {
    const data = {
      business_address: this.businessAddress,
      business_postcode: this.businessPostcode,
      business_city: this.businessCity,
      company_name: this.companyName,
      ern: this.ern,
      incomeOrigin: this.incomeOrigin,
      turnover: this.turnover,
      covers: this.covers,
      el_size: this.elSize,
    };

    return data;
  }
}

export default PolicyDetailInfoModel;
